<template>
  <div
    v-if="call.incomingTransfer"
    class="flex items-center justify-between w-full px-4 border border-orange-200 rounded bg-orange-50"
  >
    <div class="flex justify-between flex-grow">
      <div class="flex flex-col">
        <div>Number: {{ call.incomingTransfer.number }}</div>
        <div>From:{{ call.incomingTransfer.username }}</div>
      </div>
      <div class="flex flex-col justify-between text-right">
        <div class="text-xs text-gray-400">
          ({{ duration }})
        </div>
      </div>
    </div>
    <div class="flex items-center">
      <button
        title="Decline"
        class="p-2 ml-2 bg-red-100 rounded-full"
        @click="decline"
      >
        <ld-icon
          class="w-4 h-4"
          icon="XIcon"
        />
      </button>
      <button
        title="Accept"
        class="p-2 ml-2 bg-teal-100 rounded-full"
        @click="accept"
      >
        <ld-icon
          class="w-4 h-4"
          icon="CheckIcon"
        />
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { defineComponent, onMounted, onUnmounted, ref } from 'vue'
  import { useCallStore } from '/@/store/callStore'
  import { useRecordStore } from '/@/store/recordStore'
  import { Howl } from 'howler'
  import Ringtone from '/@/assets/sounds/Ringtone.ogg?url'
  import useLetsDialSocket from '/@/services/letsDialSocket/useLetsDialSocket'
  import useLetsDialPhone from '/@/services/letsDialPhone/useLetsDialPhone'
  import useLetsDialAPI from '/@/services/letsDialAPI/useLetsDialAPI'
  import { useAuthStore } from '/@/store/authStore'

  const duration = ref(10)
  let timeInterval: any
  let { socket } = useLetsDialSocket()
  const { phone } = useLetsDialPhone()
  const api = useLetsDialAPI()
  const authStore = useAuthStore()
  const call = useCallStore()
  const recordStore = useRecordStore()
  const ringVolume = authStore.user?.attributes?.additionalAttributes?.ringVolume ?? 0.5
  let sound = new Howl({
    src: [Ringtone],
    loop: true,
    volume: ringVolume,
  })
  const decline = () => {
    if (call.incomingTransfer) {
      socket.emit('user:accept:transfer', {
        callID: call.incomingTransfer.fromID,
        userID: call.incomingTransfer.userID,
        accepted: false,
      })
      call.$reset()
      if (authStore.currentStatus !== 'PAUSED' && authStore.user?.attributes.status !== 'PAUSED') {
        authStore.setAvailabilityStatus('IDLE')
      }
    }
  }
  const accept = async () => {
    if (call.incomingTransfer) {
      socket.emit('user:accept:transfer', {
        callID: call.incomingTransfer.callID,
        userID: call.incomingTransfer.fromID,
        fromID: authStore.user?.id,
        accepted: true,
      })
      if (call.incomingTransfer.conference && call.incomingTransfer.callID) {
        const conferenceCall = await api.calls.get(call.incomingTransfer.callID)
        if (conferenceCall.data?.attributes.asteriskServerIp) {
          phone.joinConference(
            call.incomingTransfer.callID,
            conferenceCall.data?.attributes.asteriskServerIp,
          )
        } else {
          console.warn(`No ConferenceCall Found for callID ${call.incomingTransfer.callID}`)
        }
      }
      console.log(call.incomingTransfer)
      if (call.incomingTransfer.recordID) {
        console.log('HAS INCOMMING TRANSFER')
        console.log(await recordStore.getRecord(call.incomingTransfer.recordID))
      }
      call.acceptTransfer()
    }
  }
  onMounted(() => {
    const ringVol = authStore.user?.attributes?.additionalAttributes?.ringVolume ?? 0.5
    sound.volume(ringVol)
    sound.play()
    timeInterval = setInterval(() => {
      duration.value = duration.value - 1
      if (duration.value <= 0) {
        decline()
      }
    }, 1000)
    if (call.incomingTransfer?.queueTransfer) {
      accept()
    }
  })
  onUnmounted(() => {
    sound.stop()
    clearInterval(timeInterval)
  })
</script>
